<header class="no-margins-hug hug-header home-header margin-vertical-header mh24" [ngClass]="{'home-ma-header': !isAcmic}">
  <div class="billing-header-acmic" *ngIf="isAcmic">
    <img 
      src="{{policy?.displayType?.icon}}"
      width="32" height="32" class="header-icon-ml" alt="home icon" 
    />
  </div>
  <div class="type-title deliquency-notice">
      <h1 class="title " [ngClass]="{ 'comm-acmic-header term-duration acmic-policy-style': isAcmic }">
        <ng-container *ngIf="!isAcmic; else acmicPolicyType">
          <span class="margin-bottom mb8 policy-type-wrap property-policy-title">
            <img 
              src="{{policy?.displayType?.icon}}"
              width="32" height="32" 
              class="margin-right mr8"
              alt="{{policy?.policyType?.toLowerCase()}} icon"
            />
            <span class="policy-display-text">{{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}</span>
             </span>
        </ng-container>
        <ng-template #acmicPolicyType>
          <span class="policy-display-text">{{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}</span>
        </ng-template>          
          <span class="policy-date-wrap" [ngClass]="{'policy-status-color': (policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE'),
          'red-color': !(policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE') }">
            <span class="reponsive-mt-8 policy-date-text"> 
              <strong class="policy-display-text" [ngClass]="{'col-363636-imp': isAcmic, 'property-policy-date': !isAcmic}">
                {{ policy?.effDate | customDateFormat }} {{ '-' | translate }}
                {{ policy?.expDate | customDateFormat }}
              </strong>
            </span>
          </span>
        </h1>
  </div>
  <ng-container *ngIf="policy?.isDelinquency">
    <div class="del-margin bn-error-notice-sec" [ngClass]="{'acmic-notice-container':isAcmic}">
      <app-bn-error-notice 
        [amount]='policy?.exitDelinquencyAmount?.theAmount' 
        [date]='policy?.policyCancellationEffectiveDate'
        [policyCancellationReason]='policy?.policyCancellationReason'
        [policy]='policy'>
      </app-bn-error-notice>
    </div>
  </ng-container>
</header>